import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router-dom'
import { FullPageWrapper } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ProviderPageDoubleOptIn } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import { DoubleOptInPageStore } from 'pages/settings/pages/doubleOptIn/store/doubleOptInPageStore'
import { DoubleOptInGroups } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInGroups/doubleOptInGroups'
import { DoubleOptInHeader } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInHeader/doubleOptInHeader'
import styles from './styles.module.scss'

const DoubleOptInPageContent = observer(() => {
  return (
    <div className={styles.page}>
      <DoubleOptInHeader />
      <DoubleOptInGroups />
    </div>
  )
})

export const DoubleOptInPage = observer(() => {
  const entities = useEntitiesContext()
  const location = useLocation()
  const store = useMemo(() => new DoubleOptInPageStore(entities), [])

  useEffect(() => {
    store.setActiveCategoryFromParam(new URLSearchParams(location.search).get('category'))
  }, [location.search, store])

  return (
    <FullPageWrapper className={styles.wrap}>
      <ProviderPageDoubleOptIn value={store}>
        <DoubleOptInPageContent />
      </ProviderPageDoubleOptIn>
    </FullPageWrapper>
  )
})
